/**
 * The file import here is tagged with @ts-ignore, because this file replace
 * main variables.ts file in /src/assets/tenants when the project is build for exact tenant(see angular.json)
 * and if the import is relatively based on current file location the build will failed,
 * because main variables.ts file is in different location than current.
 */

// @ts-ignore
import {environment} from '../../environments/environment';

/**
 * Configuration variables using in all dev and test environments
 */
export const variables = {
    tenant: 1,

    proPortalName: 'AlaricPro',
    tenEnPortalName: '10nWeb',
    fundPortalName: 'AlaricFund',
    hammerWebPortalName: 'HammerWeb',

    proRedirectUrl: `https://alaric-pro-${environment.env}.alaricsecurities.net/authentication/login`,
    tenEnRedirectUrl: `https://10n-${environment.env}.alaricsecurities.net/overview`,
    fundRedirectUrl: `https://myportal-${environment.env}.alaric.bg/authentication/login`,
    hammerWebRedirectUrl: `https://hammer-${environment.env}.alaricsecurities.net/overview`,

};
